import React, { Component } from 'react';
import {
    renderTablePartnerModal,
    renderTableSeriesModal,
    renderTableSeriesModale,
    renderTableContactModal,
    renderTableWarehouseModal,
    renderTableEmployeeModal,
    renderTableOwnerModal,
    renderTableItemsModal,
    renderTableTaxesModal,
    renderTableCentroCosteModal,
    renderTablePriceListModal,
    renderTableAccountListModal,
    renderTableInvoicesPaymentModal,
    renderTableGroupCodeModal,
    renderTableCardTypeModal,
    renderTableCardCodeReferencesModal,
    renderTableCurrencyModal,
    renderGroupNumModal,
    renderCurrenciesModal,
    renderAddressesModal,
    renderTerritoriesModal,
    renderContactPersonsPartnerModal,
    renderCountryModal,
    renderPayMethodsModal,
    renderSelectOfModal,
    renderUsersModal,
    renderBranchesModal,
    renderDepartmentsModal,
    renderTableProjectsModal,
    renderTableTransactionsModal,
    renderTablePaymnetListModal,
    renderTablePaymnetListStatusModal,
    renderTableCardsListModal,
    renderTableTransfersModal,
    renderTableTransporteModal,
    renderTableFiguraTransporteModal,
    renderTableVendorsModal,
    renderPendingDeliveries,
    renderOrderRecommendationModal,
    renderTableListMaterialModal,
    renderTableLocationsAssignment,
    renderTableUomCodeModal,
    renderTableFormattedQueriesModal,
    renderTableCutTransfersUsersModal,
    renderTableORDRTransportsModal,
} from "./index";
import ValidateItems from './ValidateItems';
import $ from "jquery";
import '../css/Toogle.css';
import moment from 'moment';

const getTableID = (view = "") => {
    switch (view) {
        case "itemsListModal": return "#dataTableItemsModal";
        case "itemsModal": return "#dataTableItemsModal";
        default: return "#dataTableCreate";
    }
}

class DataTablesCreate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            refresh: true,
            switch1: false,
            PageNumber: 1,
            itemsPage: 10,
            rows: 10,
            searchInTable: '',
            checkboxArray: (new Map()),
            nextPage: false,
            previousPage: false,
            lastPage: false,
            firstPage: false,
            dateInit: "",
            dateFinal: "",
        };
        this.table = null;
        this.documentCreateModal = null;
    }

    componentDidMount() {
        const { searchInTable, view, filterByDate } = this.props;
        if (view === 'invoicesPaymentModal' && filterByDate) {
            document.getElementById("fechaInicioInvoices").value = moment(new Date((new Date()).setMonth((new Date()).getMonth() - 1))).format('YYYY-MM-DD');
            document.getElementById("fechaFinInvoices").value = moment(new Date()).format('YYYY-MM-DD');
        }
        this.setState({ searchInTable: searchInTable });
        this.table = null;
        $('#searchDataTableCreate').val("");
        this.createDataTable(view);
    }

    createDataTable = (view) => {
        const tableId = getTableID(view);

        if ($.fn.DataTable.isDataTable(tableId)) {
            $(tableId).DataTable().destroy();
            $(tableId).empty();
        }

        setTimeout(() => {
        this.table = $(tableId).DataTable({
            "dom": '<"toolbar">frtip',
            "pagingType": "full_numbers",
            "columnDefs": [{
                "targets": 0,
                "orderable": false
            }],
            responsive: true,
        });
        this.getTableInfoResult();
        this.changePaging();
        }, 50);
    };

    getTableInfoResult = () => {
        let info = this.table.page.info();
        // console.log('con<info',info);
        let num = 0;

        if (info && info.recordsDisplay !== 0) {
            num = 1;
        }

        $('#tableInfoCreate').text((info.start + num) + " - " + info.end + " de " + info.recordsTotal);
        $('.dataTables_empty').text("No hay resultados por mostrar");
    };

    // shouldComponentUpdate = async (nextProps) => {
    //     if (this.table !== null) {
    //         this.table.destroy();
    //         this.table = null;
    //     } else {
    //         this.table = null;
    //         $('#searchDataTableCreate').val("");
    //         this.createDataTable();
    //     }
    //     return true;
    // }

    // shouldComponentUpdate = async (nextProps) => {
    //     if (this.props.view === 'claveProdSAT') {
    //         if (this.props.data !== nextProps.data) {
    //             this.table.destroy();
    //             this.table = null;
    //         }
    //         return true;
    //     }
    // }

    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    // console.log("hay nuevos datos");
    //     this.table.destroy();
    //     $('#searchDataTableCreate').val("");
    //     this.table = null;
    //     return true;
    // }

    changePaging = () => {
        const { PageNumber, searchInTable } = this.state;
        let value = $('#changePaginateSelect').val();
        this.table.page.len("10").draw();
        this.getTableInfoResult();
    };

    changePagingItems = (event) => {
        // const {PageNumber,searchInTable} = this.state;
        // let value = event.nativeEvent.target.value;
        // this.table.page.len(value).draw();
        // this.getTableInfoResult();
        // this.setState({
        //     PageNumber:1,
        //     itemsPage : value || 10,
        //     rows:value
        //  });
        //  setTimeout(() => {
        //      this.searchDocument();
        //  }, 100);
    };

    componentWillUnmount() {
        this.table = null
    }

    /* componentDidUpdate(): void {
         const { data } = this.props;
         if (data.length !== 0) {
             this.createDataTable();
         }
     }

    */

    toggleDocumentSelected = (id) => {
        const { action, view, flagInvoices, showAlert, selectOf } = this.props;
        if (view === 'VendorsModal') {
            if (this.state.checkboxArray.size === 1) {
                showAlert({ type: 'info', message: 'Solo se puede seleccionar un proveedor' });
                return;
            } else {
                const { data } = this.props;
                action(data[id]);
                return;
            }
        }

        if (view === 'transferStock') {
            if (this.state.checkboxArray.size === 1) {
                showAlert({ type: 'info', message: 'Solo se puede seleccionar un documento de traslado' });
                return;
            }
        }

        if (view === 'invoicesPaymentModal' && !flagInvoices) {
            // console.log('con<v----this.state.checkboxArray.size',this.state.checkboxArray.size);
            if (this.state.checkboxArray.size === 1) {
                showAlert({ type: 'info', message: 'Solo se puede seleccionar una factura a la vez.' });
                return;
            }
        }

        if (view === 'selectOfModal' && selectOf === 'landedCosts' && this.state.checkboxArray.size === 1) {
            showAlert({ type: 'info', message: 'Solo se puede seleccionar un documento a la vez' });
            return;
        }
        // if(view === 'itemsListModal' && this.state.checkboxArray.size === 1){
        //     showAlert({ type: 'info', message: 'Solo se puede seleccionar un artículo' });
        //     return;
        // }

        this.setState(state => {
            const checkboxArray = new Map(state.checkboxArray);
            // console.log('con<v-checkboxArray',checkboxArray);
            checkboxArray.set(id, !checkboxArray.get(id)); // toggle
            return { checkboxArray };
        });

        setTimeout(() => {
            const { checkboxArray } = this.state;
            action(checkboxArray)
        }, 100);
        // console.log('con<vflagInvoices',flagInvoices,'-----', this.state.checkboxArray.size);
    };

    toggleDocumentSelectedAll = (option) => {
        const { data, action, view, selectOf, showAlert } = this.props;
        if (view === 'selectOfModal' && selectOf === 'landedCosts') {
            showAlert({ type: 'info', message: 'Solo se puede seleccionar un documento a la vez' });
            return;
        }


        let newCheckbox = (new Map());
        data.map((register, index) => {
            newCheckbox.set(index, option)
        });
        this.setState({
            checkboxArray: newCheckbox
        });

        setTimeout(() => {
            const { checkboxArray } = this.state;
            action(checkboxArray)
        }, 100);

    };

    renderTable = () => {
        const { view, headers, data, action, edditAddres, deleteAddresses, deleteContactPersons, indexPurchaseRequest, DisabledItems, flagInvoices, refreshData, openWhsModal, EditPartnerGrp, showGroupNumModal } = this.props;
        const { checkboxArray, switch1 } = this.state;
        // console.log('con<data',data);
        let table = "";

        let checkbox = {
            data: checkboxArray,
            selectOne: this.toggleDocumentSelected,
            selectAll: this.toggleDocumentSelectedAll,
        }

        switch (view) {
            case 'partnerModal':
                table = renderTablePartnerModal(headers, data, action, indexPurchaseRequest);
                break;
            case 'seriesModal':
                table = renderTableSeriesModal(headers, data, action);
                break;
            case 'seriesModal2':
                table = renderTableSeriesModale(headers, data, action);
                break;
            case 'ContactModal':
                table = renderTableContactModal(headers, data, action);
                break;
            case 'warehouseModal':
                table = renderTableWarehouseModal(headers, data, action, switch1);
                break;
            case 'employeeModal':
                table = renderTableEmployeeModal(headers, data, action);
                break;
            case 'ownerModal':
                table = renderTableOwnerModal(headers, data, action);
                break;
            case 'itemsModal':
                table = renderTableItemsModal(headers, data, action, checkbox, DisabledItems);
                break;
            case 'taxesModal':
                table = renderTableTaxesModal(headers, data, action);
                break;
            case 'CentroCosteModal':
                table = renderTableCentroCosteModal(headers, data, action);
                break;
            case 'UomCodeModal':
                table = renderTableUomCodeModal(headers, data, action);
                break;
            case 'priceListModal':
                table = renderTablePriceListModal(headers, data, action);
                break;
            case 'AccountListModal':
                table = renderTableAccountListModal(headers, data, action);
                break;
            case 'invoicesPaymentModal':
                table = renderTableInvoicesPaymentModal(headers, data, action, checkbox, flagInvoices);
                break;
            case 'groupCodeModal':
                table = renderTableGroupCodeModal(headers, data, action, EditPartnerGrp);
                break;
            case 'cardCodeReference':
                table = renderTableCardCodeReferencesModal(headers, data, action);
                break;
            case 'cardTypeModal':
                table = renderTableCardTypeModal(headers, data, action);
                break;
            case 'currencyModal':
                table = renderTableCurrencyModal(headers, data, action);
                break;
            case 'groupNumModal':
                table = renderGroupNumModal(headers, data, action, showGroupNumModal);
                break;
            case 'currenciesModal':
                table = renderCurrenciesModal(headers, data, action);
                break;
            case 'addressesModal':
                table = renderAddressesModal(headers, data, action, edditAddres, deleteAddresses);
                break;
            case 'territoriesModal':
                table = renderTerritoriesModal(headers, data, action);
                break;
            case 'contactPersonsPartnerModal':
                table = renderContactPersonsPartnerModal(headers, data, action, deleteContactPersons);
                break;
            case 'countryModal':
                table = renderCountryModal(headers, data, action);
                break;
            case 'payMethodsModal':
                table = renderPayMethodsModal(headers, data, action);
                break;
            case 'selectOfModal':
                table = renderSelectOfModal(headers, data, action, checkbox);
                break;
            case 'usersModal':
                table = renderUsersModal(headers, data, action);
                break;
            case 'branchesModal':
                table = renderBranchesModal(headers, data, action);
                break;
            case 'departmentsModal':
                table = renderDepartmentsModal(headers, data, action);
                break;
            case 'projectsModal':
                table = renderTableProjectsModal(headers, data, action);
                break;
            case 'transactionsModal':
                table = renderTableTransactionsModal(headers, data, action);
                break;
            case 'paymentListModaL':
                table = renderTablePaymnetListModal(headers, data, action);
                break;
            case 'paymentStatusListModal':
                table = renderTablePaymnetListStatusModal(headers, data, action);
                break;
            case 'cardsListModal':
                table = renderTableCardsListModal(headers, data, action);
                break;
            case 'transferStock':
                table = renderTableTransfersModal(headers, data, action, checkbox, flagInvoices);
                break;
            case 'TransporteListModal':
                table = renderTableTransporteModal(headers, data, action, checkbox, flagInvoices);
                break;
            case 'FiguraTransporteListModal':
                table = renderTableFiguraTransporteModal(headers, data, action, checkbox, flagInvoices);
                break;
            case 'VendorsModal':
                table = renderTableVendorsModal(headers, data, action, checkbox);
                break;
            case 'pendingDeliveries':
                table = renderPendingDeliveries(headers, data, action, checkbox, flagInvoices);
                break;
            case 'orderRecommendation':
                table = renderOrderRecommendationModal(headers, data, action, checkbox, refreshData, openWhsModal);
                break;
            case 'itemsListModal':
                table = renderTableItemsModal(headers, data, action, checkbox, DisabledItems);
                break;
            case 'ListMaterialModal':
                table = renderTableListMaterialModal(headers, data, action, checkbox, DisabledItems);
                break;
            case 'listLocationsAssignment':
                table = renderTableLocationsAssignment(headers, data, action);
                break;
            case 'formattedQueries':
                table = renderTableFormattedQueriesModal(headers, data, action, switch1);
                break;
            case 'cutTransferUsersModal':
                table = renderTableCutTransfersUsersModal(headers, data, action);
                break;
            case 'ORDRTransports':
                table = renderTableORDRTransportsModal(headers, data, action);
                break;
            default:
                table = "";
        }
        return table;
    };

    searchInTable = key => {
        const { view, search } = this.props;
        let value = key.target.value;
        if (view === 'partnerModal' || view === 'itemsModal' || view === 'itemsListModal' || view === 'ListMaterialModal' || view === 'listLocationsAssignment') {

            this.setState({
                searchInTable: value,
                PageNumber: 1,
                rows: 10
            });
            setTimeout(() => {
                search(value, 1);
            }, 100);

        } else {
            this.setState({
                searchInTable: value,
            });
            let tabla = $(getTableID(view)).DataTable();
            tabla.search(value);
            tabla.draw();
            this.getTableInfoResult();
        }
    }

    addToTable = () => {
        const { addItemBack, } = this.props;
        const { nextPage, previousPage, firstPage, lastPage } = this.state;

        if (nextPage) {
            this.nextPages();
            this.resetPage();
        }
        if (previousPage) {
            this.previousPages();
            this.resetPage();
        }
        if (firstPage) {
            this.firstPages();
            this.resetPage();
        }
        if (lastPage) {
            this.lastPages();
            this.resetPage();
        }
        addItemBack();
    }

    continuePage = () => {
        const { nextPage, previousPage, firstPage, lastPage } = this.state;
        if (nextPage) {
            this.nextPages();
            this.resetPage();
        }
        if (previousPage) {
            this.previousPages();
            this.resetPage();
        }
        if (firstPage) {
            this.firstPages();
            this.resetPage();
        }
        if (lastPage) {
            this.lastPages();
            this.resetPage();
        }
    }

    resetPage() {
        this.setState({
            nextPage: false,
            previousPage: false,
            firstPage: false,
            lastPage: false
        });
    }

    first = () => {
        const { view, saveData } = this.props;
        const { PageNumber, rows, checkboxArray } = this.state;
        if (view === 'partnerModal' || view === 'itemsModal' || view === 'itemsListModal' || view === 'ListMaterialModal' || view === 'listLocationsAssignment') {
            this.setState({
                firstPage: true
            });
            let bandera = true;
            for (let [id, value] of checkboxArray.entries()) {
                if (value) {
                    bandera = false;
                }
            }
            if (!bandera && saveData) {
                $('#validateItems').modal('show');
                return;
            } else if (!bandera && !saveData) {
                setTimeout(() => {
                    this.addToTable();
                }, 100);

            } else {
                this.firstPages();
            }
        } else {
            this.table.page('first').draw('page');
            this.getTableInfoResult();
        }


    }

    firstPages = () => {
        const { view } = this.props;

        this.setState({
            PageNumber: 1,
            rows: 10
        });
        setTimeout(() => {
            this.searchDocument();
        }, 100);



    }

    previous = () => {
        const { PageNumber, rows, checkboxArray } = this.state;
        const { view, saveData } = this.props;
        if (view === 'partnerModal' || view === 'itemsModal' || view === 'itemsListModal' || view === 'ListMaterialModal' || view === 'listLocationsAssignment') {
            this.setState({
                previousPage: true
            });
            let bandera = true;

            for (let [id, value] of checkboxArray.entries()) {
                if (value) {
                    bandera = false;
                }
            }
            if (!bandera && saveData) {
                $('#validateItems').modal('show');
                return;
            } else if (!bandera && !saveData) {
                setTimeout(() => {
                    this.addToTable();
                }, 100);

            } else {
                this.previousPages();
            }

        } else {
            this.table.page('previous').draw('page');
            this.getTableInfoResult();
        }
    }

    previousPages = () => {
        const { PageNumber, rows } = this.state;
        const { view } = this.props;
        let previousPage = PageNumber;
        let row = rows;
        if ((PageNumber - 1) > 0) {
            previousPage -= 1;
            if (row - 10 > 0) {
                row -= 10;
            }

        }
        this.setState({
            PageNumber: previousPage,
            rows: row,
        });
        setTimeout(() => {
            this.searchDocument();
        }, 100);
    }

    next = () => {
        const { rows, PageNumber, checkboxArray } = this.state;
        const { view, totalPage, saveData } = this.props;
        if (view === 'partnerModal' || view === 'itemsModal' || view === 'itemsListModal' || view === 'ListMaterialModal' || view === 'listLocationsAssignment') {
            this.setState({
                nextPage: true
            });
            let bandera = true;

            for (let [id, value] of checkboxArray.entries()) {
                if (value) {
                    bandera = false;
                }
            }
            if (!bandera && saveData) {
                $('#validateItems').modal('show');
                return;
            } else if (!bandera && !saveData) {
                setTimeout(() => {
                    this.addToTable();
                }, 100);

            } else {
                this.nextPages();
            }

        } else {
            this.table.page('next').draw('page');
            this.getTableInfoResult();
        }
    }

    nextPages = () => {
        const { rows, PageNumber, checkboxArray } = this.state;
        const { view, totalPage } = this.props;
        let total = totalPage || 10
        let last = Math.ceil(total / 10);
        let nexPage = PageNumber;
        let row = rows;
        if (PageNumber < last) {
            nexPage += 1;
            if (row < total - 10) {
                row += 10;
            }
        }
        this.setState({
            PageNumber: nexPage,
            rows: row
        });

        setTimeout(() => {
            this.searchDocument();
        }, 100);
    }

    last = () => {
        const { rows, checkboxArray } = this.state;
        const { totalPage, view, saveData } = this.props;

        if (view === 'partnerModal' || view === 'itemsModal' || view === 'itemsListModal' || view === 'ListMaterialModal' || view === 'listLocationsAssignment') {
            this.setState({
                lastPage: true
            });
            let bandera = true;

            for (let [id, value] of checkboxArray.entries()) {
                if (value) {
                    bandera = false;
                }
            }
            if (!bandera && saveData) {
                $('#validateItems').modal('show');
                return;
            } else if (!bandera && !saveData) {
                setTimeout(() => {
                    this.addToTable();
                }, 100);

            } else {
                this.lastPages();
            }
        } else {
            this.table.page('last').draw('page');
            this.getTableInfoResult();
        }
    }

    lastPages = () => {
        const { rows } = this.state;
        const { totalPage, view } = this.props;


        let total = totalPage || 10;
        let last = Math.ceil(total / 10);
        let row = rows;
        row = (last - 1) * 10;

        this.setState({
            PageNumber: last,
            rows: row
        });

        setTimeout(() => {
            this.searchDocument();
        }, 100);

    }

    searchDocument = async () => {
        const { search } = this.props;
        const { PageNumber, searchInTable, itemsPage } = this.state;
        search(searchInTable, PageNumber);

        //limpiar checkbox
        this.setState({
            checkboxArray: new Map()
        });
    };

    searchDocuments = async () => {
        const { view, search, filterByDate } = this.props;
        const { checkboxArray, PageNumber } = this.state;
        let date = {
            // dateInit: moment(document.getElementById("fechaInicioSelectOf").value).format('YYYYMMDD'),
            // dateFinal: moment(document.getElementById("fechaFinSelectOf").value).format('YYYYMMDD'),
            dateInit: null,
            dateFinal: null
        };


        if (view === 'selectOfModal') {
            const { search } = this.props;
            await search(date);
        } else if (view === 'invoicesPaymentModal' && filterByDate) {
            date = {
                dateInit: moment(document.getElementById("fechaInicioInvoices").value).format('YYYYMMDD'),
                dateFinal: moment(document.getElementById("fechaFinInvoices").value).format('YYYYMMDD'),
            };
            this.toggleDocumentSelectedAll(false);

            this.setState({
                checkboxDataTables: (new Map()),
            });
            search(date);
        } else {
            date = {
                PageNumber
            }

            search(date);

        }
    };

    refreshDates = () => {
        // setTimeout(()=> {
        //     document.getElementById("fechaInicioSelectOf").value = moment(new Date()).format('YYYY-MM-DD');
        //     document.getElementById("fechaFinSelectOf").value = moment(new Date()).format('YYYY-MM-DD');
        // },100)
    };

    handleSwitchChange = nr => () => {
        let switchNumbers = `switch${nr}`;
        this.setState({
            switch1: !this.state[switchNumbers]
        });
        // this.render();
    }

    render() {
        const { view, totalPage, showStock, filterByDate } = this.props;
        const { switch1, PageNumber, rows, searchInTable, nextPage } = this.state;

        return (
            <div>
                <ValidateItems
                    addToTable={this.addToTable}
                    nextPage={nextPage}
                    nextPages={this.nextPages}
                    continuePage={this.continuePage} />

                {/* {view == 'selectOfModal' &&
                <div className="search-div row">
                    <div className=" col-md-6" style={{display: "inline-flex", width: 250}}>
                        <label><strong>Desde:&nbsp;&nbsp;</strong></label>
                        <input id="fechaInicioSelectOf" style={{width: "45%", important: true}}
                               className="form-control btn-outline-secondary listSerie" type="date"
                               placeholder="Fecha min" autoComplete="off"
                               max='9999-12-31'
                               onKeyDown={event => event.keyCode == 13 && this.searchDocuments()}/>
                        <label><strong> &nbsp;&nbsp;Hasta:&nbsp;&nbsp;</strong></label>
                        <input id="fechaFinSelectOf" style={{width: "45%", important: true}}
                               className="form-control btn-outline-secondary listSerie" type="date"
                               max='9999-12-31'
                               placeholder="Fecha min" autoComplete="off"
                               onKeyDown={event => event.keyCode == 13 && this.searchDocuments()}/>
                        <button className="btn btn-active" data-toggle="tooltip" data-placement="top"
                                title="Buscar por fecha" onClick={this.searchDocuments}>
                            <i className="fas fa-search"></i>
                        </button>
                    </div>
                    <div className=" col-md-6" style={{display: "inline-flex", width: 250}}>
                    </div>
                </div>
                } */}

                {view === 'invoicesPaymentModal' && filterByDate &&
                    <div className='form-inline'>
                        <div className="form-group mb-2 mr-1">
                            <label className="Desde"><strong>Desde:&nbsp;&nbsp;</strong></label>
                            <input id="fechaInicioInvoices"
                                className="form-control btn-outline-secondary listSerie " type="date"
                                placeholder="Fecha min" autoComplete="off"
                                max='9999-12-31'
                                onKeyDown={event => event.keyCode === 13 && this.searchDocuments()} />
                        </div>
                        <div className="form-group mb-2">
                            <label className="Hasta"><strong> &nbsp;&nbsp;Hasta:&nbsp;&nbsp;</strong></label>
                            <input id="fechaFinInvoices"
                                className="form-control btn-outline-secondary listSerie " type="date"
                                placeholder="Fecha min" autoComplete="off"
                                max='9999-12-31'
                                onKeyDown={event => event.keyCode === 13 && this.searchDocuments()} />
                        </div>
                        <button className="btn btn-active" data-toggle="tooltip" data-placement="top" title="Buscar" onClick={this.searchDocuments}>
                            <i className="fas fa-search"></i>
                        </button>
                    </div>
                }
                <div className="search-div row">
                    <div className="col-md-12" style={{ width: '100%' }}>
                        <input className='form-control btn-outline-secondary dropdown-toggle listSerie hide-pc'
                            style={{ display: 'inline-flex' }} placeholder="Buscar" autoComplete="off"
                            id='searchDataTableCreate'
                            type='search' aria-controls='dataTableTimbra' value={searchInTable || ''} onChange={this.searchInTable} />
                    </div>
                    {/* { view === 'selectOfModal' && 
                    <div className="col-sm-1">
                        <button className="btn btn-active ml-2" data-toggle="tooltip" data-placement="top"
                                title="Buscar por fecha" onClick={this.searchDocuments}>
                            <i className="fas fa-search"></i>
                        </button>
                    </div>} */}
                    {/* {view === 'itemsModal' &&
                    <div>
                        <select
                            className="form-control  form-control-sm select-rows-page btn-outline-secondary listSerie"
                            style={{width: '85'}}
                            id='changePaginateSelect'
                            onChange={this.changePagingItems}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>&nbsp;&nbsp;
                    </div>     
                    }                             */}
                </div>
                {view === 'warehouseModal' && showStock &&
                    <div className="search-div row">
                        <div className=" col-md-6"></div>
                        <div className=" col-md-4"></div>
                        <div className=" col-md-2">
                            <label className="switch" >
                                Stock
                            </label>

                            <label className="switch" >
                                <input type="checkbox"
                                    checked={switch1}
                                    onChange={this.handleSwitchChange(1)} />
                                <span className="slider round"></span>
                            </label>
                        </div>
                    </div>}
                {/* {view === 'itemsModal' &&
                <div className="search-div row">
                    <div className=" col-md-2"></div>
                    <div className=" col-md-4"></div>
                        <div className=" col-md-6">
                                <label>
                                    Mostrar artículos solo con stock disponible  
                                </label>
                                &nbsp;
                                <label className="switch" >
                                    <input type="checkbox"  
                                    checked={switch1} 
                                    onChange={this.handleSwitchChange(1)}/>
                                    <span className="slider round"></span>
                                </label>
                        </div>
                </div>} */}

                <div className="w-100 table-scroll">
                    {this.renderTable()}
                </div>
                <div className="navigation-tabs " style={{ textAlign: "right" }}>
                    <div className="form-row navigation-tabs2">
                        {/*<label htmlFor="colFormLabelSm" className="col col-form-label col-form-label-sm text-right"
                               style={{width: 195}}>
                            Registros por página:
                        </label>
                        <div className="col-sm-2">
                            <select
                                className="form-control  form-control-sm select-rows-page col btn-outline-secondary listSerie"
                                style={{width: '10'}}
                                id='changePaginateSelect'
                                onChange={this.changePaging}>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>&nbsp;&nbsp;
                        </div>*/}
                        {view !== 'partnerModal' && view !== 'itemsModal' && view !== 'itemsListModal' && view !== 'ListMaterialModal' && view !== 'listLocationsAssignment' ?
                            <label htmlFor="colFormLabelSm" id="tableInfoCreate"
                                className="col-form-label col-form-label-sm">
                            </label> :
                            <label
                                className="col-form-label col-form-label-sm">
                                {rows} de {totalPage}
                            </label>}
                        <div className="col btn-navigation-tabs">
                            <button className="btn btn-link btn-sm " style={{ color: "black" }} data-toggle="tooltip"
                                data-placement="top"
                                title="Primera" onClick={this.first}><i
                                    className="fas fa-chevron-left btn-first"></i></button>
                            <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                                data-placement="top"
                                title="Anterior" onClick={this.previous}><i
                                    className="fas fa-chevron-left"></i></button>
                            {(view === 'partnerModal' || view === 'itemsModal' || view === 'itemsListModal' || view === 'ListMaterialModal' || view === 'listLocationsAssignment') &&
                                <label htmlFor="colFormLabelSm"
                                    className="col-form-label col-form-label-sm">
                                    {PageNumber}
                                </label>}
                            <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                                data-placement="top"
                                title="Siguiente" onClick={this.next}><i
                                    className="fas fa-chevron-right"></i></button>
                            <button className="btn btn-link btn-sm" style={{ color: "black" }} data-toggle="tooltip"
                                data-placement="top"
                                title="Última" onClick={this.last}><i
                                    className="fas fa-chevron-right btn-last"></i></button>
                        </div>

                    </div>
                </div>
                <br></br>

            </div>
        );
    }
}

export default DataTablesCreate;